import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { LineItem, Order } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const getOrderByNumberAndEmail = (payload: { orderNumber: string; customerEmail: string }) => $fetch<BFFResponse<Order>>(`/orders/withNumber/${payload.orderNumber}`, { query: { customerEmail: payload.customerEmail } });

  const getGuestOrder = (orderNumber: string, withCustomFields: boolean) => $fetch<BFFResponse<Order>>(`/orders/${orderNumber}`, { method: 'POST', body: { withCustomFields } });

  const createGuestReturn = async <T>(orderId: string, orderNumber: string, lineItems: LineItem[]) => $fetch<BFFResponse<T>>(`/orders/${orderId}/rma`, { method: 'POST', body: { orderNumber, lineItems } });

  const cancelGuestReturn = async <T>(orderId: string, returnTrackingId: string, orderNumber: string) => $fetch<BFFResponse<T>>(`/orders/${orderId}/rma/${returnTrackingId}`, { method: 'DELETE', body: { orderNumber } });

  const getReturnLabel = async <T>(orderId: string, returnTrackingId: string) => $fetch<BFFResponse<T>>(`/orders/${orderId}/rma/${returnTrackingId}/label`);

  const getOrderInvoice = async (orderId: string, orderNumber: string) => $fetch<BFFResponse<Blob>>(`/orders/${orderId}/invoices`, { query: { orderNumber }, headers: { Accept: 'application/pdf' } });

  return {
    getOrderByNumberAndEmail,
    getGuestOrder,
    createGuestReturn,
    cancelGuestReturn,
    getReturnLabel,
    getOrderInvoice,
  };
};
